/**
 * Favicon URL utilities — always routes through the backend proxy to avoid
 * CORS errors that occur when the browser calls Google's favicon service via
 * the Fetch API. The backend fetches server-side and caches results for 24 h.
 */

/**
 * Returns the proxied favicon URL for a given domain.
 */
export function getFaviconUrl(domain: string, size: number = 32): string {
  return `/api/mail/favicon?domain=${encodeURIComponent(domain)}&sz=${size}`;
}

/**
 * Extracts the hostname from a URL and returns the proxied favicon URL.
 * Returns empty string if the URL is invalid.
 */
export function getFaviconUrlForUrl(url: string, size: number = 16): string {
  try {
    const { hostname } = new URL(url);
    return getFaviconUrl(hostname, size);
  } catch {
    return '';
  }
}
